var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"sns_login_wrap mr22 naver",on:{"click":_vm.triggerNaver}},[_c('a',{staticStyle:{"display":"none"},attrs:{"id":"naverIdLogin"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }